import React, { Fragment } from 'react';
import { number, string, func, oneOfType, object } from 'prop-types';
import List from './List';
import ListItem from './ListItem';

const propTypes = {
  id: oneOfType([number, string]).isRequired,
  item: object.isRequired,
  onItemChange: func.isRequired,
  onSubItemsChange: func.isRequired,
  handleListItemChange: func.isRequired,
  index: number.isRequired,
};
const defaultProps = {
  id: '',
  item: {},
};

const ListGroup = ({
  id,
  item,
  onClick,
  onItemChange,
  onSubItemsChange,
  handleListItemChange,
  index,
  className,
}) => (
  <li className={className} onClick={() => onClick(item.id)}>
    <ListItem
      name={`${name}[]`}
      id={id}
      title={item.title}
      value={item.id}
      onChange={e => handleListItemChange(item.id, e, true)}
      checked={item.checked}
      tag={Fragment}
    />
    <List
      items={item.subParams}
      name={name}
      onItemChange={onItemChange}
      onSubItemsChange={onSubItemsChange}
      parentIndex={index}
      parentId={item.id}
      hasParent
    />
  </li>
);

ListGroup.propTypes = propTypes;
ListGroup.defaultProps = defaultProps;

export default ListGroup;
